const submitStyles = {
  fontSize: '16px !important',
  bg: 'linear-gradient(180deg, #3B31F2 0%, #2c23c7 100%) !important',
  w: '100% !important',
  h: '54px !important',
  color: 'white !important',
  borderRadius: '8px !important'
};

const secondaryStyles = {
  fontSize: '16px',
  fontWeight: '600',
  bg: '#991ad3',
  borderRadius: '8px !important',
  color: 'white'
};

const standartStyles = {
  fontSize: '16px',
  fontWeight: '600',
  bg: '#ccc',
  borderRadius: '8px !important',
  color: 'white'
};

const ghostStyles = {
  fontSize: '16px',
  fontWeight: '600',
  color: '#fad125',
  _focus: {
    bg: 'transparent !important',
  },
  _hover: {
    bg: 'transparent !important',
  },
  _active: {
    bg: 'transparent !important',
  }
};

const deleteStyles = {
  bg: '#BA1A1A'
};

export const buttonStyles = {
  components: {
    Button: {
      variants: {
        'submit': submitStyles,
        'submit-md': {
          ...submitStyles, 
          h: '44px',
          p: '12px',
        },
        'submit-ms': {
          ...submitStyles, 
          h: '40px',
          p: '11px'
        },
        'submit-sm': {
          ...submitStyles, 
          h: '36px',
          p: '8px'
        },
        'submit-md-delete': {
          ...submitStyles, 
          ...deleteStyles,
          h: '44px',
          p: '12px'
        },
        'secondary': {
          ...secondaryStyles
        },
        'secondary-lg': {
          ...secondaryStyles,
          h: '66px',
          p: '12px 30px',
        },
        'secondary-md': {
          ...secondaryStyles,
          h: '44px',
          p: '12px',
        },
        'secondary-ms': {
          ...secondaryStyles, 
          h: '40px',
          p: '11px'
        },
        'secondary-sm': {
          ...secondaryStyles, 
          h: '36px',
          p: '8px'
        },
        'ghost': {
          ...ghostStyles,
        },
        'ghost-md': {
          ...ghostStyles,
          h: '44px',
          p: '12px',
        },
        'ghost-ms': {
          ...ghostStyles, 
          h: '40px',
          p: '11px'
        },
        'ghost-sm': {
          ...ghostStyles, 
          h: '36px',
          p: '8px'
        },
        'menuitem': {
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '400',
          color: 'blue.900',
          mx: '-5px',
          px: '0',
          mb: '-2px',
          mt: '-2px',
          _focus: {
            bg: 'transparent !important',
          },
          _hover: {
            bg: 'transparent !important',
          },
          _active: {
            bg: 'transparent !important',
          }
        }
      },
      baseStyle: {
        bg: 'unset',
        w: '100% !important',
        _focus: {
          boxShadow: 'none',
        },
      },
    }
  }
};
